import StoresBulkIndex from '../stores_bulk_index';

document.addEventListener('DOMContentLoaded', () => {
  const storesForQuery = document.getElementById('stores_for_query') as HTMLElement;
  const queryInput = document.getElementById('query') as HTMLInputElement;

  type storeAttributes = { id: number, name: string };
  type resultStore = { attributes: storeAttributes };
  type resultStores = { data: Array<resultStore> };

  if (storesForQuery == null) {
    return;
  }

  queryInput.addEventListener('focus', () => {
    getStores();
    showStoresForQuery();
  });

  const showStoresForQuery = () => {
    storesForQuery.style.display = 'block';
  }

  const hideStoresForQuery = () => {
    storesForQuery.style.display = 'none';
  }

  document.addEventListener('click', (e) => {
    if(!(e.target as HTMLElement).closest('.query-form')) {
      hideStoresForQuery();
    }
  })

  queryInput.addEventListener('keyup', () => {
    if (queryInput.value) {
      hideStoresForQuery();
    } else {
      showStoresForQuery();
    }
  });

  const renderStores = (stores: Array<resultStore>) => {
    const ul = storesForQuery.querySelector('ul') as HTMLElement;
    var index = 0;
    [].forEach.call(stores, store => {
      index += 1;
      const li = document.createElement('li');
      const storeAttributes = (store as resultStore).attributes;
      li.innerText = storeAttributes.name;
      ul.appendChild(li);
      if (index == stores.length) {
        // クリックイベントをセット
        const lis = ul.children;
        [].forEach.call(lis, li => {
          (li as HTMLElement).addEventListener('click', () => {
            queryInput.value = (li as HTMLElement).innerHTML;
            hideStoresForQuery();
          });
        });
      }
    });
  }

  const renderTitle = (stores: Array<resultStore>) => {
    const title = storesForQuery.querySelector('.title') as HTMLElement;
    title.innerText = '候補一覧 (全' + stores.length + '件)';
  }

  const hideLoading = () => {
    const loading = document.getElementById('stores_for_query_loading') as HTMLElement;
    loading.style.display = 'none';
  }

  const addLoadedClass = () => {
    storesForQuery.classList.add('loaded');
  }

  const getStores = () => {
    if (!storesForQuery.classList.contains('loaded')) {
      // 一度だけ店舗情報を取得する
      addLoadedClass();
      const client = new StoresBulkIndex();
      client.getStores([]).then((data) => {
        renderStores((data as resultStores).data);
        renderTitle((data as resultStores).data)
        hideLoading();
      });
    }
  }
});
